import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 20px 0;
  padding: 12px;
  border: 1px solid #444;
  color: #e1d6c0;
`;
const Row = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  input { flex:1; background:#111; color:#fff; padding:6px; border:1px solid #666; }
  button { padding:6px 12px; background:transparent; border:1px solid #e1d6c0; color:#e1d6c0; }
`;

export default function SlideEditor({ token, onChange }) {
  const [slides, setSlides] = useState([]);
  useEffect(() => {
    fetch('/api/slides', { headers: { Authorization: 'Bearer '+token } })
      .then(r=>r.json()).then(setSlides)
      .catch(()=>alert('Couldn’t load slides'));
  }, [token, onChange]);

  const save = async (i) => {
    const s = slides[i];
    const method = s.id ? 'PUT' : 'POST';
    const url = s.id 
      ? `/api/admin/slides/${s.id}`
      : `/api/admin/slides`;
    const body = JSON.stringify({
      image_url: s.image_url,
      position: s.position,
      caption:   s.caption
    });
    const res = await fetch(url, {
      method, headers: {
        'Content-Type':'application/json',
        Authorization:'Bearer '+token
      },
      body
    });
    if (!res.ok) return alert('Save failed');
    const updated = await res.json();
    const copy = [...slides];
    copy[i] = updated;
    setSlides(copy);
    onChange();
  };

  const remove = async (i) => {
    const s = slides[i];
    if (!s.id) return setSlides(slides.filter((_,j)=>j!==i));
    const res = await fetch(`/api/admin/slides/${s.id}`, {
      method:'DELETE',
      headers:{ Authorization:'Bearer '+token }
    });
    if (!res.ok) return alert('Delete failed');
    setSlides(slides.filter((_,j)=>j!==i));
    onChange();
  };

  const add = () => setSlides([...slides, { image_url:'', position:slides.length+1, caption:'' }]);

  return (
    <Wrapper>
      <h3>Image (any image URL and Position in slide) </h3>
      {slides.map((s,i) => (
        <Row key={s.id||i}>
          <input
            placeholder="Image URL"
            value={s.image_url}
            onChange={e => {
              const copy = [...slides];
              copy[i].image_url = e.target.value;
              setSlides(copy);
            }}
          />
          <input
            type="number"
            placeholder="Position"
            value={s.position}
            onChange={e => {
              const copy = [...slides];
              copy[i].position = +e.target.value;
              setSlides(copy);
            }}
          />
          <button onClick={()=>save(i)}>Save</button>
          <button onClick={()=>remove(i)}>Delete</button>
        </Row>
      ))}
      <button onClick={add}>Add Slide</button>
    </Wrapper>
  );
}
